import React from "react";

/**
 * Keeps a failed PDF preview inside its own tile.
 *
 * pdf.js throws synchronously when a document is torn down while one of its
 * pages is still resolving — "Cannot read properties of null (reading
 * 'sendWithPromise')". That happens whenever react-pdf swaps or unmounts a
 * <Document> mid-load, e.g. switching gallery tabs while a PDF is still
 * fetching. The app mounts a single Sentry.ErrorBoundary at the root, so
 * without a boundary here that one error replaces the entire page with the
 * generic "Sorry, something went wrong" screen.
 */
class PdfErrorBoundary extends React.Component {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error) {
    console.error("PDF preview failed:", error);
  }

  componentDidUpdate(prevProps) {
    // A different file deserves a fresh attempt rather than inheriting the
    // previous one's failure.
    if (this.state.failed && prevProps.resetKey !== this.props.resetKey) {
      this.setState({ failed: false });
    }
  }

  render() {
    if (this.state.failed) return this.props.fallback ?? null;
    return this.props.children;
  }
}

export default PdfErrorBoundary;
